import {
  NewsboardPost,
  NewsboardPostBody,
  NewsboardPostFooter,
  NewsboardPostHeader,
} from '../../Newsboard'
import { Container } from '../Container'

import {
  POST_ITEM,
  POST_ITEM_AUDIENCE,
  POST_ITEM_GALLERY,
  POST_ITEM_RATING,
  POST_ITEM_TODAY,
} from './Newsboard.mock'

function Newsboard() {
  return (
    <>
      <Container label='Newsboard content body'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostBody data={POST_ITEM_AUDIENCE} />
        </div>
      </Container>
      <Container label='Newsboard content body'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostBody data={POST_ITEM_TODAY} />
        </div>
      </Container>
      <Container label='Newsboard content body gallery'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostBody data={POST_ITEM_GALLERY} />
        </div>
      </Container>
      <Container label='Newsboard content body reting'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostBody data={POST_ITEM_RATING} />
        </div>
      </Container>
      <Container label='Newsboard content skeleton'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostBody loading />
        </div>
      </Container>
      <Container label='Newsboard header, pinned'>
        <div style={{ width: '680px' }}>
          <NewsboardPostHeader data={POST_ITEM} />
        </div>
      </Container>
      <Container label='Newsboard header status online today'>
        <div style={{ minWidth: '680px' }}>
          <NewsboardPostHeader data={POST_ITEM_TODAY} />
        </div>
      </Container>
      <Container label='Newsboard header skeleton'>
        <div style={{ minWidth: '680px' }}>
          <NewsboardPostHeader loading />
        </div>
      </Container>
      <Container label='Newsboard footer'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostFooter data={POST_ITEM_TODAY} />
        </div>
      </Container>
      <Container label='Newsboard footer liked'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostFooter data={POST_ITEM} />
        </div>
      </Container>
      <Container label='Newsboard footer skeleton'>
        <div style={{ maxWidth: '680px', minWidth: '680px' }}>
          <NewsboardPostFooter loading />
        </div>
      </Container>
      <Container label='Newsboard post'>
        <NewsboardPost value={POST_ITEM_AUDIENCE} />
      </Container>
      <Container label='Newsboard post'>
        <NewsboardPost value={POST_ITEM_TODAY} />
      </Container>
      <Container label='Newsboard post'>
        <NewsboardPost value={POST_ITEM} />
      </Container>
    </>
  )
}

export default Newsboard
